import { useParams, useLocation } from 'react-router-dom';
import { ScheduleItemDetails } from 'components/contexts/schedule';
import { Container } from 'components/structure';

type Params = {
  id: string;
};

export const ScheduleDetails = () => {
  const { pathname } = useLocation();
  const pathnameSchedule = pathname.split('/')[1];
  const { id } = useParams() as Params;

  return (
    <Container shedule={pathnameSchedule}>
      <ScheduleItemDetails id={id} />
    </Container>
  );
};
